// extracted by mini-css-extract-plugin
export default {"wrapper":"ChannelBlock_wrapper__lUI1E","paddingBottom":"ChannelBlock_paddingBottom__1QobW","media":"ChannelBlock_media__k5RRH","loadingWrapper":"ChannelBlock_loadingWrapper__NtUY5"};